export enum EModalTypes {
  CREATE_BULK_OPERATIONS = 'CREATE_BULK_OPERATIONS',
  CONFIRMATION = 'CONFIRMATION',
  ADVANCED_FEATURE = 'ADVANCED_FEATURE'
}
